@if (audiences().length > 0) {
  <div class="agent-audience-list">
    @for (audience of audiences(); track audience.id) {
      <button
        type="button"
        class="agent-audience-list__item"
        [attr.aria-label]="'agent.audience.open' | translate: { name: audience.name }"
        (click)="openAudience.emit(audience)">
        <mat-icon class="agent-audience-list__icon">group</mat-icon>
        <span class="agent-audience-list__name">
          {{ audience.name }}
          @if (audience.isDefault) {
            <span class="agent-audience-list__badge">{{ "agent.audience.default" | translate }}</span>
          }
        </span>
        <mat-icon class="agent-audience-list__chevron">chevron_right</mat-icon>
      </button>
    }
  </div>
}
